import { fetchResource } from "@src/app/utils";
import { z } from "zod";
import { historyTrackListSchema, tracklistCommentSchema } from "./schemas";
import type { CommentRating } from "./types";

/**
 * Fetch all tracklist comments
 */
export const getTrackListComments = (uuid: string, page = 1) =>
	fetchResource(`tracklist/${uuid}/comments?page=${page}`, z.array(tracklistCommentSchema));

/**
 * Fetch paginated user's comments
 */
export const getHistory = (page = 1) =>
	fetchResource(`tracklist/comment/history?page=${page}`, z.array(historyTrackListSchema), "GET", undefined, {
		apiVersion: "v2",
	});

/**
 * Delete specific tracklist
 */
export const deleteComment = (uuid: string) =>
	fetchResource(`tracklist/comment/${uuid}`, z.object({}), "DELETE", undefined, { emptyResponse: true });

/**
 * Rate comment
 */
export const putRateComment = (uuid: string, value: CommentRating) =>
	fetchResource(
		`tracklist/comment/${uuid}/rating`,
		z.object({}),
		"PUT",
		{ value },
		{
			emptyResponse: true,
		},
	);
